import Types from '../types';

export default (reducerState = [], action) => {
  switch (action.type) {
    case Types.SET_HIDDEN_GRADES:
      return action.payload;
    default:
      return reducerState;
  }
};
